/* eslint-disable no-useless-constructor */
import FieldModel from './FieldModel';
import { SelectInput } from '../inputs';

class SelectField extends FieldModel {
  /**
   * @param {Object} params
   * @param {string} params.kWord Unique object key (from plans)
   * @param {string} params.label Input label, used on the field filter
   * @param {boolean} [params.required] If the input is required (not empty)
   * @param {boolean} [params.removed] Condition to not render and use this field
   * @param {boolean} [params.disabled] Condition to block this field (still visible)
   * @param {any} [params.default] Default (initial) value
   * @param {[{
   *  value: any, label: string, id: string
   * }]} params.options Select options list
   * @param {boolean} [params.multiple] If can select multiple options
   */
  constructor(params) {
    super(params);
  }

  getDefaultState = () => ({
    ...(this.default ?? this.options[0]),
    error: Boolean(this.required),
    errorMsg: this.required ? 'Este campo não pode estar vazio' : '',
  });

  genFormatedState = (value) => (
    value ? {
      ...(this.options.find((o) => o.value === value) ?? { value, label: value }),
      error: false,
      errorMsg: '',
    } : null
  )

  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (value) => handle({
      [this.kWord]: {
        ...value,
        error: false,
        errorMsg: '',
      },
    });
    return (
      <SelectInput
        label={this.label}
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
        options={this.options}
        isMultiple={this.multiple ?? false}
      />
    );
  }
}

export default SelectField;
